import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
} from "@mui/material";
import {
  StyledTableCellValueTemplate,
  StyledTableCellLabelTemplate,
  LabelTemplate,
  StyledTableRowTemplate,
  StyledTableContainer,
} from "../../styles/table";
import { Employee } from "../../../types/processTypes";

import { tt } from "../../../../../data/langUtility";
import { Check } from "@mui/icons-material";
import Close from "@mui/icons-material/Close";
import { BasicRate } from "./BasicRate";
import { format, isValid } from "date-fns";

interface Props {
  currentEmployee: Employee;
  template: LabelTemplate;
  showEducation?: boolean | false;
  showOtherLanguage?: boolean | false;
}
export const BasicLanguage = ({
  currentEmployee,
  template,
  showEducation,
  showOtherLanguage,
}: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "33%",
                }}
              >
                {tt("language", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{ width: "34%" }}
              ></StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                  width: "33%",
                }}
              >
                {tt("language", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("arabic", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {tt(
                  currentEmployee.education?.arabicLanguage as string,
                  template.cvLang,
                )}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("arabic", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="1">
              <StyledTableCellLabelTemplate template={template}>
                {tt("english", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {tt(
                  currentEmployee.education?.englishLanguage as string,
                  template.cvLang,
                )}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("english", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            {showEducation && (
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("education_level", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {tt(
                    currentEmployee.education?.educationLevel as string,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("education_level", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
            {showOtherLanguage && (
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("other", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {tt("ethiopian", template.cvLang)}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("other", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicLanguageGolden = ({
  currentEmployee,
  template,
  showEducation,
  showOtherLanguage,
}: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          {/* <TableHead>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                colSpan={3}
                sx={{
                  textAlign: "center",
                }}
              >
                {tt("language", "en")}
                {tt("language", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead> */}
          <TableBody>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("arabic", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                }}
              >
                {tt("arabic", "ar")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {tt(
                  currentEmployee.education?.arabicLanguage as string,
                  template.cvLang,
                )}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="1">
              <StyledTableCellLabelTemplate template={template}>
                {tt("english", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("english", "ar")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {tt(
                  currentEmployee.education?.englishLanguage as string,
                  template.cvLang,
                )}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
            {showEducation && (
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("education_level", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("education_level", "ar")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {tt(
                    currentEmployee.education?.educationLevel as string,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            )}
            {showOtherLanguage && (
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("other", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("other", "ar")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {tt("ethiopian", template.cvLang)}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicLanguageEnglish = ({
  currentEmployee,
  template,
  showEducation,
  showOtherLanguage,
}: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                colSpan={2}
                template={template}
                sx={{
                  textAlign: "center",
                }}
              >
                {tt("language", "en")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{ width: "25%" }}
              >
                {tt("arabic", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{ textAlign: "left" }}
              >
                {tt(
                  currentEmployee.education?.arabicLanguage as string,
                  template.cvLang,
                )}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="1">
              <StyledTableCellLabelTemplate template={template}>
                {tt("english", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{ textAlign: "left" }}
              >
                {tt(
                  currentEmployee.education?.englishLanguage as string,
                  template.cvLang,
                )}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
            {showEducation && (
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("education_level", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {tt(
                    currentEmployee.education?.educationLevel as string,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            )}
            {showOtherLanguage && (
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("other", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {tt("ethiopian", template.cvLang)}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};
export const BasicLanguageEnglishNoHeader = ({
  currentEmployee,
  template,
  showEducation,
  showOtherLanguage,
}: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                colSpan={2}
                template={template}
                sx={{
                  textAlign: "center",
                }}
              >
                {tt("education_level", "en")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            {showOtherLanguage && (
              <>
                <StyledTableRowTemplate template={template} key="0">
                  <StyledTableCellLabelTemplate
                    template={template}
                    sx={{ width: "25%" }}
                  >
                    {tt("arabic", "en")}
                  </StyledTableCellLabelTemplate>
                  <StyledTableCellValueTemplate template={template}>
                    {tt(
                      currentEmployee.education?.arabicLanguage as string,
                      template.cvLang,
                    )}
                  </StyledTableCellValueTemplate>
                </StyledTableRowTemplate>
                <StyledTableRowTemplate template={template} key="1">
                  <StyledTableCellLabelTemplate template={template}>
                    {tt("english", "en")}
                  </StyledTableCellLabelTemplate>
                  <StyledTableCellValueTemplate template={template}>
                    {tt(
                      currentEmployee.education?.englishLanguage as string,
                      template.cvLang,
                    )}
                  </StyledTableCellValueTemplate>
                </StyledTableRowTemplate>
                <StyledTableRowTemplate template={template} key="10">
                  <StyledTableCellLabelTemplate template={template}>
                    {tt("other", "en")}
                  </StyledTableCellLabelTemplate>
                  <StyledTableCellValueTemplate template={template}>
                    {tt("ethiopian", template.cvLang)}
                  </StyledTableCellValueTemplate>
                </StyledTableRowTemplate>
              </>
            )}
            {showEducation && (
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellValueTemplate
                  template={template}
                  colSpan={2}
                  sx={{ textAlign: "center" }}
                >
                  {tt(
                    currentEmployee.education?.educationLevel as string,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicLanguageDetail = ({ currentEmployee, template }: Props) => {
  const arabic = currentEmployee.education?.arabicLanguage as string;
  const english = currentEmployee.education?.englishLanguage as string;
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                colSpan={2}
                sx={{
                  textAlign: "left",
                  width: "50%",
                }}
              >
                {tt("language_knowledge", "en")}
              </StyledTableCellLabelTemplate>

              <StyledTableCellLabelTemplate
                template={template}
                colSpan={2}
                sx={{
                  textAlign: "right",
                  width: "50%",
                }}
              >
                {tt("language_knowledge", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                }}
              >
                {tt("english", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("english2", "ar")}
              </StyledTableCellLabelTemplate>

              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                }}
              >
                {tt("arabic", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("arabic2", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("poor", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {english === "poor" ? <Check /> : <Close />}
              </StyledTableCellValueTemplate>

              <StyledTableCellValueTemplate template={template}>
                {arabic === "poor" ? <Check /> : <Close />}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("poor", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("fair", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {english === "fair" ? <Check /> : <Close />}
              </StyledTableCellValueTemplate>

              <StyledTableCellValueTemplate template={template}>
                {arabic === "fair" ? <Check /> : <Close />}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("fair", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("good", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {english === "good" ? <Check /> : <Close />}
              </StyledTableCellValueTemplate>

              <StyledTableCellValueTemplate template={template}>
                {arabic === "good" ? <Check /> : <Close />}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("good", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("fluent", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {english === "fluent" || english === "good" ? (
                  <Check />
                ) : (
                  <Close />
                )}
              </StyledTableCellValueTemplate>

              <StyledTableCellValueTemplate template={template}>
                {arabic === "fluent" || arabic === "good" ? (
                  <Check />
                ) : (
                  <Close />
                )}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("fluent", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};
export const BasicLanguageDetailMuta = ({
  currentEmployee,
  template,
}: Props) => {
  const arabic = currentEmployee.education?.arabicLanguage as string;
  const english = currentEmployee.education?.englishLanguage as string;
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                colSpan={2}
                sx={{
                  textAlign: "left",
                  width: "50%",
                }}
              >
                {tt("language_knowledge", "en")}
              </StyledTableCellLabelTemplate>

              <StyledTableCellLabelTemplate
                template={template}
                colSpan={2}
                sx={{
                  textAlign: "right",
                  width: "50%",
                }}
              >
                {tt("language_knowledge", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                }}
              >
                {tt("english", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("english2", "ar")}
              </StyledTableCellLabelTemplate>

              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                }}
              >
                {tt("arabic", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("arabic2", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("poor", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {english === "poor" ? "YES" : ""}
              </StyledTableCellValueTemplate>

              <StyledTableCellValueTemplate template={template}>
                {arabic === "poor" ? "YES" : ""}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("poor", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("fair", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {english === "fair" ? "YES" : ""}
              </StyledTableCellValueTemplate>

              <StyledTableCellValueTemplate template={template}>
                {arabic === "fair" ? "YES" : ""}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("fair", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("good", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {english === "good" ? "YES" : ""}
              </StyledTableCellValueTemplate>

              <StyledTableCellValueTemplate template={template}>
                {arabic === "good" ? "YES" : ""}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("good", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            {/* <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("fluent", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {english === "fluent" || english === "good" ? (
                  "YES"
                ) : (
                  ""
                )}
              </StyledTableCellValueTemplate>

              <StyledTableCellValueTemplate template={template}>
                {arabic === "fluent" || arabic === "good" ? (
                  "YES"
                ) : (
                  ""
                )}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("fluent", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate> */}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};
export const BasicLanguageMaleda = ({ currentEmployee, template }: Props) => {
  const arabic = currentEmployee.education?.arabicLanguage as string;
  const english = currentEmployee.education?.englishLanguage as string;
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                colSpan={1}
                width="25%"
                sx={{
                  textAlign: "left",
                }}
              >
                {tt("language_knowledge", "en")}
              </StyledTableCellLabelTemplate>

              <StyledTableCellLabelTemplate
                template={template}
                colSpan={1}
                width="50%"
                sx={{
                  textAlign: "center",
                }}
              ></StyledTableCellLabelTemplate>

              <StyledTableCellLabelTemplate
                template={template}
                colSpan={1}
                width="25%"
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("language_knowledge", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                rowSpan={4}
                template={template}
                sx={{
                  textAlign: "left",
                }}
              >
                {tt("english", "en")}
                <br />
                {tt("english2", "ar")}
              </StyledTableCellLabelTemplate>

              <StyledTableCellLabelTemplate
                rowSpan={4}
                template={template}
                sx={{
                  textAlign: "center",
                }}
              >
                <Table>
                  <TableBody>
                    <StyledTableRowTemplate template={template} key="100">
                      <StyledTableCellLabelTemplate
                        template={template}
                        colSpan={3}
                        sx={{ textAlign: "center" }}
                      >
                        Status
                      </StyledTableCellLabelTemplate>
                    </StyledTableRowTemplate>

                    <StyledTableRowTemplate template={template} key="10">
                      <StyledTableCellValueTemplate template={template}>
                        {english === "poor" ? <Check /> : <Close />}
                      </StyledTableCellValueTemplate>
                      <StyledTableCellLabelTemplate
                        template={template}
                        sx={{ textAlign: "center" }}
                      >
                        {tt("poor2", "en")}
                        <br />
                        {tt("poor2", "ar")}
                      </StyledTableCellLabelTemplate>

                      <StyledTableCellValueTemplate template={template}>
                        {arabic === "poor" ? <Check /> : <Close />}
                      </StyledTableCellValueTemplate>
                    </StyledTableRowTemplate>

                    <StyledTableRowTemplate template={template} key="20">
                      <StyledTableCellValueTemplate template={template}>
                        {english === "good" ? <Check /> : <Close />}
                      </StyledTableCellValueTemplate>
                      <StyledTableCellLabelTemplate
                        template={template}
                        sx={{ textAlign: "center" }}
                      >
                        {tt("good", "en")}
                        <br />
                        {tt("good", "ar")}
                      </StyledTableCellLabelTemplate>

                      <StyledTableCellValueTemplate template={template}>
                        {arabic === "good" ? <Check /> : <Close />}
                      </StyledTableCellValueTemplate>
                    </StyledTableRowTemplate>

                    <StyledTableRowTemplate template={template} key="30">
                      <StyledTableCellValueTemplate template={template}>
                        {english === "fluent" || english === "good" ? (
                          <Check />
                        ) : (
                          <Close />
                        )}
                      </StyledTableCellValueTemplate>
                      <StyledTableCellLabelTemplate
                        template={template}
                        sx={{ textAlign: "center" }}
                      >
                        {tt("fluent", "en")}
                        <br />
                        {tt("fluent", "ar")}
                      </StyledTableCellLabelTemplate>

                      <StyledTableCellValueTemplate template={template}>
                        {arabic === "fluent" || arabic === "good" ? (
                          <Check />
                        ) : (
                          <Close />
                        )}
                      </StyledTableCellValueTemplate>
                    </StyledTableRowTemplate>
                  </TableBody>
                </Table>
              </StyledTableCellLabelTemplate>

              <StyledTableCellLabelTemplate
                rowSpan={4}
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("arabic", "en")}
                <br />
                {tt("arabic2", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};
export const BasicLanguageLevels = ({ currentEmployee, template }: Props) => {
  const arabic = currentEmployee.education?.arabicLanguage as string;
  const english = currentEmployee.education?.englishLanguage as string;
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                colSpan={2}
                sx={{
                  textAlign: "left",
                  width: "50%",
                }}
              >
                {tt("language_knowledge", "en")}
              </StyledTableCellLabelTemplate>

              <StyledTableCellLabelTemplate
                template={template}
                colSpan={2}
                sx={{
                  textAlign: "right",
                  width: "50%",
                }}
              >
                {tt("language_knowledge", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                }}
              >
                {tt("english", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("english2", "ar")}
              </StyledTableCellLabelTemplate>

              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                }}
              >
                {tt("arabic", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("arabic2", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("fluent", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {english === "fluent" || english === "good" ? (
                  <Check />
                ) : (
                  <Close />
                )}
              </StyledTableCellValueTemplate>

              <StyledTableCellValueTemplate template={template}>
                {arabic === "fluent" || arabic === "good" ? (
                  <Check />
                ) : (
                  <Close />
                )}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("fluent", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>

            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("average", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {english === "fair" ? <Check /> : <Close />}
              </StyledTableCellValueTemplate>

              <StyledTableCellValueTemplate template={template}>
                {arabic === "fair" ? <Check /> : <Close />}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("average", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>

            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("poor2", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {english === "poor" ? <Check /> : <Close />}
              </StyledTableCellValueTemplate>

              <StyledTableCellValueTemplate template={template}>
                {arabic === "poor" ? <Check /> : <Close />}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("poor2", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicLanguageStar = ({
  currentEmployee,
  template,
  showEducation,
  showOtherLanguage,
}: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "33%",
                }}
              >
                {tt("language", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{ width: "34%" }}
              ></StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                  width: "33%",
                }}
              >
                {tt("language", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("arabic", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                <BasicRate
                  currentEmployee={currentEmployee}
                  template={template}
                  rateType="arabic"
                />
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("arabic", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="1">
              <StyledTableCellLabelTemplate template={template}>
                {tt("english", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                <BasicRate
                  currentEmployee={currentEmployee}
                  template={template}
                  rateType="english"
                />
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("english", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            {showEducation && (
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("education_level", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {tt(
                    currentEmployee.education?.educationLevel as string,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("education_level", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
            {showOtherLanguage && (
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("other", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {tt("ethiopian", template.cvLang)}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("other", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicLanguageNoLabels = ({
  currentEmployee,
  template,
  showEducation,
  showOtherLanguage,
}: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableBody>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellValueTemplate
                template={template}
                sx={{ textAlign: "center" }}
              >
                {tt(
                  currentEmployee.education?.arabicLanguage as string,
                  template.cvLang,
                )}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="1">
              <StyledTableCellValueTemplate
                template={template}
                sx={{ textAlign: "center" }}
              >
                {tt(
                  currentEmployee.education?.englishLanguage as string,
                  template.cvLang,
                )}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
            {showEducation && (
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("education_level", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {tt(
                    currentEmployee.education?.educationLevel as string,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("education_level", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
            {showOtherLanguage && (
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("other", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {tt("ethiopian", template.cvLang)}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("other", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicLanguageUltra = ({
  currentEmployee,
  template,
  showEducation,
  showOtherLanguage,
}: Props) => {
  const documentReceivedRaw =
    currentEmployee?.additionalData?.documentReceivedDate;
  const documentReceivedParsed =
    documentReceivedRaw != null ? new Date(documentReceivedRaw) : null;
  const documentReceivedFormatted =
    documentReceivedParsed != null && isValid(documentReceivedParsed)
      ? format(documentReceivedParsed, "dd-MMM-yyyy")
      : "";

  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableBody>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "45%",
                  backgroundColor: template.headBgColor,
                  color: template.headFontColor,
                }}
              >
                {tt("education_qualification", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  width: "10%",
                  backgroundColor: template.headBgColor,
                  color: template.headFontColor,
                }}
              ></StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                  width: "45%",
                  backgroundColor: template.headBgColor,
                  color: template.headFontColor,
                }}
              >
                {tt("education_level", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "33%",
                }}
              ></StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{ width: "34%" }}
              >
                {tt(
                  currentEmployee.education?.educationLevel as string,
                  template.cvLang,
                )}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                  width: "33%",
                }}
              ></StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "33%",
                  backgroundColor: template.headBgColor,
                  color: template.headFontColor,
                }}
              >
                {tt("telephone", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  width: "34%",
                  backgroundColor: template.headBgColor,
                  color: template.headFontColor,
                }}
              ></StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                  width: "33%",
                  backgroundColor: template.headBgColor,
                  color: template.headFontColor,
                }}
              >
                {tt("telephone", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "33%",
                }}
              ></StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{ width: "34%" }}
              >
                {currentEmployee.address
                  ? (currentEmployee.address?.telephone as string)
                  : ""}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                  width: "33%",
                }}
              ></StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "43%",
                  backgroundColor: template.headBgColor,
                  color: template.headFontColor,
                }}
              >
                {tt("applicationDate", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  width: "24%",
                  backgroundColor: template.headBgColor,
                  color: template.headFontColor,
                }}
              ></StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                  width: "33%",
                  backgroundColor: template.headBgColor,
                  color: template.headFontColor,
                }}
              >
                {tt("applicationDate", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "33%",
                }}
              ></StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{ width: "34%" }}
              >
                {documentReceivedFormatted}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                  width: "33%",
                }}
              ></StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "33%",
                  backgroundColor: template.headBgColor,
                  color: template.headFontColor,
                }}
              >
                {tt("language", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  width: "34%",
                  backgroundColor: template.headBgColor,
                  color: template.headFontColor,
                }}
              ></StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                  width: "33%",
                  backgroundColor: template.headBgColor,
                  color: template.headFontColor,
                }}
              >
                {tt("language", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("arabic", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {tt(
                  currentEmployee.education?.arabicLanguage as string,
                  template.cvLang,
                )}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("arabic", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="1">
              <StyledTableCellLabelTemplate template={template}>
                {tt("english", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {tt(
                  currentEmployee.education?.englishLanguage as string,
                  template.cvLang,
                )}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("english", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            {showEducation && (
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("education_level", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {tt(
                    currentEmployee.education?.educationLevel as string,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("education_level", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
            {showOtherLanguage && (
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("other", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {tt("ethiopian", template.cvLang)}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("other", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicLanguageInaya = ({ currentEmployee, template }: Props) => {
  const arabic = currentEmployee.education?.arabicLanguage as string;
  const english = currentEmployee.education?.englishLanguage as string;
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                colSpan={2}
                sx={{
                  textAlign: "left",
                  width: "50%",
                }}
              >
                {tt("language_knowledge", "en")}
              </StyledTableCellLabelTemplate>

              <StyledTableCellLabelTemplate
                template={template}
                colSpan={2}
                sx={{
                  textAlign: "right",
                  width: "50%",
                }}
              >
                {tt("language_knowledge", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "40%",
                }}
              >
                {`${tt("language", "en")}/${tt("language", "ar")}`}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              >
                {`${tt("read", "en")}/${tt("read", "ar")}`}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              >
                {`${tt("write", "en")}/${tt("write", "ar")}`}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              >
                {`${tt("speak", "en")}/${tt("speak", "ar")}`}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "40%",
                }}
              >
                {`${tt("english", "en")}/${tt("english2", "ar")}`}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              ></StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              ></StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              >
                {english === "fluent" || english === "good" ? "YES" : ""}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "40%",
                }}
              >
                {`${tt("arabic", "en")}/${tt("arabic2", "ar")}`}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              ></StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              ></StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              >
                {arabic === "fluent" || arabic === "good" ? "YES" : ""}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicLanguageInayaEnglishOnly = ({
  currentEmployee,
  template,
}: Props) => {
  const arabic = currentEmployee.education?.arabicLanguage as string;
  const english = currentEmployee.education?.englishLanguage as string;
  const amharic = currentEmployee.education?.amharicLanguage as string;
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template}>
              <StyledTableCellLabelTemplate
                template={template}
                colSpan={4}
                sx={{
                  textAlign: "left",
                }}
              >
                KNOWLEDGE OF LANGUAGE
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template}>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{ textAlign: "left", width: "25%" }}
              >
                SKILL
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{ textAlign: "center", width: "25%" }}
              >
                ENGLISH
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{ textAlign: "center", width: "25%" }}
              >
                ARABIC
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{ textAlign: "center", width: "25%" }}
              >
                AMHARIC
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template}>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{ textAlign: "left" }}
              >
                READING
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{ textAlign: "center" }}
              >
                NO
              </StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{ textAlign: "center" }}
              >
                NO
              </StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{ textAlign: "center" }}
              >
                NO
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template}>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{ textAlign: "left" }}
              >
                WRITING
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{ textAlign: "center" }}
              >
                NO
              </StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{ textAlign: "center" }}
              >
                NO
              </StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{ textAlign: "center" }}
              >
                NO
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template}>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{ textAlign: "left" }}
              >
                SPEAKING
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{ textAlign: "center" }}
              >
                {english === "fluent" || english === "good" ? "YES" : "NO"}
              </StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{ textAlign: "center" }}
              >
                {arabic === "fluent" || arabic === "good" ? "YES" : "NO"}
              </StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{ textAlign: "center" }}
              >
                {amharic === "fluent" || amharic === "good" ? "YES" : "NO"}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};
export const BasicLanguageMermaid = ({ currentEmployee, template }: Props) => {
  const arabic = currentEmployee.education?.arabicLanguage as string;
  const english = currentEmployee.education?.englishLanguage as string;
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                colSpan={2}
                sx={{
                  textAlign: "left",
                  width: "50%",
                }}
              >
                {tt("language", "en")}
              </StyledTableCellLabelTemplate>

              <StyledTableCellLabelTemplate
                template={template}
                colSpan={2}
                sx={{
                  textAlign: "right",
                  width: "50%",
                }}
              >
                {tt("language", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="34">
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "40%",
                }}
              >
                {`LEVEL`}
              </StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              >
                {`GOOD`}
              </StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              >
                {`FAIR`}
              </StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              >
                {`LITTLE`}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="36">
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "40%",
                }}
              >
                {`${tt("english", "en")}`}
              </StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              ></StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              ></StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              >
                {english === "fluent" || english === "good" ? "YES" : ""}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
            <StyledTableRowTemplate template={template} key="39">
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "40%",
                }}
              >
                {`${tt("arabic", "en")}`}
              </StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              ></StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              ></StyledTableCellValueTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "20%",
                }}
              >
                {arabic === "fluent" || arabic === "good" ? "YES" : ""}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};
